import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { concat, get, includes, isEmpty, map, toUpper, without } from 'lodash'

import { setCategories } from '../../../redux/actions/setFilters'
import { enableCategoreisFilterLabel } from '../../../configuration/configs'
import FilterPopoverWrapper from '../../elements/FilterPopoverWrapper'
import Checkbox from '../../elements/Checkbox'
import labels from '../../../configuration/labels'
import CaretDownIcon from '../../../assets/icons/caret-down.svg'

const CategoriesFilter = () => {
  const eventsData = useSelector(state => state.eventsData)
  const activeCategories = useSelector(state => state.filtersData.categories)
  const [currentFilters, setCurrentFilters] = useState(activeCategories)
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const dispatch = useDispatch()
  const isSmallScreen = window.innerWidth < 700
  let availableCategories = null

  useEffect(() => {
    setCurrentFilters(activeCategories)
    setIsActive(!isEmpty(activeCategories))
  }, [activeCategories])

  const togglePopover = () => {
    setIsPopoverOpen(status => !status)
  }

  const onToggleFilter = useCallback(
    event => {
      const filterId = get(event, 'target.id')

      if (filterId === 'All') {
        setCurrentFilters([])
      } else if (includes(currentFilters, filterId)) {
        setCurrentFilters(without(currentFilters, filterId))
      } else {
        setCurrentFilters(concat(currentFilters, filterId))
      }
    },
    [currentFilters]
  )

  const onSubmitFilters = useCallback(() => {
    dispatch(setCategories(currentFilters))
    setIsPopoverOpen(false)
  }, [dispatch, currentFilters])

  if (eventsData && eventsData.data && eventsData.data.categories) {
    availableCategories = eventsData.data.categories
  }

  return (
    <div
      id="categories-filter"
      className="decoupled-events__filters-bar-categories"
    >
      {enableCategoreisFilterLabel && labels.filterLabelCategories && (
        <h4>{labels.filterLabelCategories}</h4>
      )}
      <FilterPopoverWrapper
        alignment={isSmallScreen ? 'end' : 'start'}
        containerParent="categories-filter"
        popoverClassName="popover-category"
        isPopoverOpen={isPopoverOpen}
        onClosePopover={() => setIsPopoverOpen(false)}
        onSubmit={onSubmitFilters}
        PopoverTab={
          <button className={`filter-tab ${isActive ? 'active' : ''}`} onClick={togglePopover}>
            {toUpper(labels.filteredEventsCategory)}
            {!isEmpty(activeCategories) && <span>{`(${activeCategories.length})`}</span>}
            <img src={CaretDownIcon} alt={isPopoverOpen ? 'Close' : 'Open'} />
          </button>
        }
      >
        <Checkbox
          key={'All'}
          id={'All'}
          label={'All'}
          onChange={onToggleFilter}
          value={isEmpty(currentFilters)}
        />
        {map(availableCategories, availableCategory => (
          <Checkbox
            key={availableCategory}
            id={availableCategory}
            label={availableCategory}
            onChange={onToggleFilter}
            value={includes(currentFilters, availableCategory)}
          />
        ))}
      </FilterPopoverWrapper>
    </div>
  )
}

export default CategoriesFilter
